import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const checkToken = localStorage.getItem("token");

  return checkToken ? children : <Navigate to="/auth/login" />;
}
